module.exports = __webpack_public_path__ + "img/features_scoremaster_phone.760e25d4.jpg";